import React from 'react'
import { Container, Wrapper, Header } from '../../../components_renew/Layout'
import TurntableBackground from '../../../assets/xiniu/turntable/turntable-wrapper.png'
import TurntableMain from './TurntableMain'
import TurntableCarousel from './TurntableCarousel'
// import TurntableBlock from './TurntableBlock'
import { Modal } from 'antd-mobile'
import classnames from 'classnames'

class RuleButton extends React.PureComponent {
  render () {
    return <div>
      <div className={'turntable__rule'} onClick={this.onClick}>活动规则</div>
    </div>
  }

  onClick = () => {
    Modal.alert({
      title: '活动规则',
      content: <div>
        1. 活动有效期：见图有效；<br/>
        2. 活动对象：所有注册用户均可参与；<br/>
        3. 参与方式：1个自然日内，消耗指定积分（以活动页展示为准）可获1次转盘机会，每个自然日最高可获得10次转盘机会；<br/>
        4. 转盘中可见奖品随机送出，中奖率100%；<br/>
        【订购券】用于预售商城预订商品时抵扣订金（仅一次使用）<br/>
        【零售券】用于零售商城购买任意商品时候抵扣现金（仅一次使用）<br/>
        【积分】用于积分商城任意积分活动<br/>
        5.积分长期有效；订购券、零售券自获得日起7天有效，逾期未使用视为放弃；<br/>
        6. 发放时间：一经参与，奖品即刻到账！可至『我的』-『我的卡券』或『积分商城』查看；<br/>
        7. 如需帮助请在线留言，平台将第一时间为您服务（服务时间：周一至周五 9:00-12:00 14:00-17:30 ）<br/>
        8. 应用内一切抽奖活动与苹果公司及相关应用市场无关，最终解释权归本APP所有。<br/>
      </div>
    }).then()
  }
}

class Turntable extends React.PureComponent {
  constructor (props) {
    super(props)
    const { search: SearchParams } = props.location
    const urlParams = new URLSearchParams(SearchParams)
    this.withHeader = urlParams.get('withHeader')
  }

  componentDidMount () {
    document.title = '轮盘抽奖'
  }

  render () {
    return <Container className={'turntable__container turntable__container--xiniu'}>
      {/*<Wrapper className={'turntable__wrapper'}>*/}
      <Wrapper transparent className={classnames('turntable__wrapper', { 'turntable__wrapper--header': this.withHeader })}>
        <RuleButton/>
        <img src={TurntableBackground} className={'turntable__bg'} alt=""/>
        <div style={{ position: 'relative' }}>
          {this.withHeader ? <Header ghost/> : null}
          <TurntableMain/>
          <TurntableCarousel/>
          <br/>
          {/* 2021-07-01 业务需求 去掉*/}
          {/*<TurntableBlock />*/}
        </div>

      </Wrapper>
    </Container>
  }

}

export default Turntable
